import React, { useState } from "react";
// ✅ Import your API function
import { submitSupportQuery } from "../../utils/api";

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [statusMsg, setStatusMsg] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.name || !form.email || !form.message) {
      return setStatusMsg({ type: "error", text: "Please fill in all fields." });
    }

    setSending(true);
    setStatusMsg({ type: "", text: "" });

    try {
      await submitSupportQuery(form);
      setStatusMsg({ type: "success", text: "✅ Message sent! We will reply within 24 hours." });
      setForm({ name: "", email: "", message: "" }); 
    } catch (err) {
      setStatusMsg({ 
        type: "error", 
        text: err.response?.data?.error || err.message || "Could not connect to server." 
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {/* 🎨 ALL PREMIUM CSS IN ONE PLACE */}
      <style>{`
        /* --- Wrapper & Background --- */
        .cu-wrapper {
          background: linear-gradient(135deg, #dff6ff, #f7edff);
          min-height: 100vh;
          padding: 50px 20px;
          font-family: 'Segoe UI', Roboto, Helvetica, sans-serif;
          display: flex;
          justify-content: center;
        }

        .cu-container {
          width: 100%;
          max-width: 600px;
          animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1);
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* --- Header --- */
        .cu-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .cu-title {
          font-size: 34px;
          font-weight: 900;
          color: #005eff;
          margin: 0 0 5px 0;
          letter-spacing: -0.5px;
        }

        .cu-subtitle {
          font-size: 16px;
          color: #64748b;
          margin: 0;
          font-weight: 500;
        }

        /* --- Quick Contact Grid --- */
        .cu-grid {
          display: flex;
          gap: 15px;
          margin-bottom: 25px;
        }

        .cu-contact-box {
          flex: 1;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 20px;
          text-align: center;
          text-decoration: none;
          box-shadow: 0 10px 25px rgba(0, 94, 255, 0.05);
          transition: all 0.3s ease;
          border: 1px solid #ffffff;
        }

        .cu-contact-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 15px 35px rgba(0, 94, 255, 0.12);
          border-color: #bfdbfe;
        }

        .cu-icon {
          width: 54px;
          height: 54px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          margin: 0 auto 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        .phone-icon { background: #eff6ff; color: #2563eb; }
        .email-icon { background: #fff7ed; color: #ea580c; }

        .cu-label {
          display: block;
          font-size: 16px;
          font-weight: 800;
          color: #1e293b;
          margin-bottom: 4px;
        }

        .cu-detail {
          display: block;
          font-size: 13px;
          color: #64748b;
          font-weight: 600;
        }

        /* --- Form Card --- */
        .cu-form-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 35px;
          box-shadow: 0 15px 40px rgba(0, 94, 255, 0.08);
          border: 1px solid #ffffff;
        }

        .cu-form-title {
          font-size: 24px;
          font-weight: 900;
          color: #1e293b;
          margin: 0 0 5px 0;
        }

        .cu-form-sub {
          font-size: 14px;
          color: #94a3b8;
          margin: 0 0 25px 0;
          font-weight: 600;
        }

        /* --- Form Inputs --- */
        .cu-input-group {
          margin-bottom: 20px;
        }

        .cu-input-group label {
          display: block;
          font-size: 12px;
          font-weight: 800;
          color: #64748b;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .cu-input-group input,
        .cu-input-group textarea {
          width: 100%;
          background: #f8fafc;
          border-radius: 14px;
          padding: 16px;
          border: 2px solid #f1f5f9;
          font-size: 15px;
          color: #1e293b;
          font-weight: 600;
          outline: none;
          transition: all 0.3s ease;
          box-sizing: border-box;
          font-family: inherit;
        }

        .cu-input-group textarea {
          min-height: 120px;
          resize: vertical;
        }

        .cu-input-group input:focus,
        .cu-input-group textarea:focus {
          background: #ffffff;
          border-color: #005eff;
          box-shadow: 0 0 0 4px rgba(0, 94, 255, 0.1);
        }

        /* --- Submit Button --- */
        .cu-submit-btn {
          width: 100%;
          background: linear-gradient(90deg, #005eff, #0098ff);
          color: white;
          padding: 18px;
          border-radius: 16px;
          font-size: 16px;
          font-weight: 800;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 10px 20px rgba(0, 94, 255, 0.2);
          margin-top: 10px;
        }

        .cu-submit-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 15px 25px rgba(0, 94, 255, 0.3);
        }

        .cu-submit-btn:disabled {
          background: #cbd5e1;
          box-shadow: none;
          cursor: not-allowed;
          transform: none;
        }

        /* --- Status Banners --- */
        .cu-status-banner {
          padding: 14px 18px;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        .cu-status-banner.error {
          background: #fef2f2;
          color: #e11d48;
          border-left: 4px solid #e11d48;
        }

        .cu-status-banner.success {
          background: #f0fdf4;
          color: #16a34a;
          border-left: 4px solid #16a34a;
        }

        /* --- Responsive --- */
        @media (max-width: 600px) {
          .cu-grid { flex-direction: column; gap: 12px; }
          .cu-wrapper { padding: 30px 15px; }
          .cu-form-card { padding: 25px 20px; }
        }
      `}</style>

      {/* 🖥️ UI HTML STRUCTURE */}
      <div className="cu-wrapper">
        <div className="cu-container">
          
          <div className="cu-header">
            <h2 className="cu-title">Help Center</h2>
            <p className="cu-subtitle">We’re here to help you anytime.</p>
          </div>

          <div className="cu-grid">
            <a href="tel:+919876543210" className="cu-contact-box phone">
              <div className="cu-icon phone-icon">📞</div>
              <span className="cu-label">Call Us</span>
              <span className="cu-detail">+91 9179328717</span>
            </a>

            <a href="mailto:vyangosupport@gmail.com" className="cu-contact-box email">
              <div className="cu-icon email-icon">✉️</div>
              <span className="cu-label">Email Us</span>
              <span className="cu-detail">vyangosupport@gmail.com</span>
            </a>
          </div>

          <div className="cu-form-card">
            <h3 className="cu-form-title">Write to us</h3>
            <p className="cu-form-sub">Our team typically replies in 24 hours.</p>

            <form onSubmit={handleSubmit} className="cu-form">
              <div className="cu-input-group">
                <label>Name</label>
                <input 
                  type="text" 
                  name="name"
                  placeholder="Your Name" 
                  value={form.name}
                  onChange={handleChange}
                  required 
                />
              </div>

              <div className="cu-input-group">
                <label>Email</label>
                <input 
                  type="email" 
                  name="email"
                  placeholder="Your Email Address" 
                  value={form.email}
                  onChange={handleChange}
                  required 
                />
              </div>

              <div className="cu-input-group">
                <label>Message</label>
                <textarea 
                  name="message"
                  placeholder="Describe how we can help you..." 
                  value={form.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              {statusMsg.text && (
                <div className={`cu-status-banner ${statusMsg.type}`}>
                  {statusMsg.text}
                </div>
              )}

              <button type="submit" className="cu-submit-btn" disabled={sending}>
                {sending ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

        </div>
      </div>
    </>
  );
}